export default {
  'accessPolicy.globalSettings.mfaPolicy': 'Política MFA',
  'accessPolicy.globalSettings.evaluationMode': 'Modo de evaluación',
  'accessPolicy.globalSettings.defaultDecision': 'Decisión por defecto',

  'accessPolicy.defaultDecision.allow': 'Permitir',
  'accessPolicy.defaultDecision.deny': 'Denegar',

  'accessPolicy.title': 'Políticas de Acceso',
  'accessPolicy.columns.name': 'Nombre',
  'accessPolicy.columns.effect': 'Efecto',
  'accessPolicy.columns.priority': 'Prioridad',
  'accessPolicy.filters.active': 'Activo',
  'accessPolicy.filters.effect': 'Efecto',

  'accessPolicy.evaluationMode.denyOverrides': 'Denegar prevalece',
  'accessPolicy.evaluationMode.allowOverrides': 'Permitir prevalece',
  'accessPolicy.evaluationMode.firstMatch': 'Primera coincidencia',

  'accessPolicy.mfaRequirement.notRequired': 'MFA no obligatorio',
  'accessPolicy.mfaRequirement.adminsOnly': 'Solo administradores',
  'accessPolicy.mfaRequirement.allUsers': 'Todos los usuarios',

  'accessPolicy.actions.duplicate': 'Duplicar',

  'accessPolicy.definition.logicalOperator': 'Operador lógico',
  'accessPolicy.definition.rules': 'Reglas',
  'accessPolicy.definition.groups': 'Grupos',
  'accessPolicy.definition.groupTitle': 'Grupo {index} (nivel {depth})',
  'accessPolicy.definition.ruleType': 'Tipo de regla',
  'accessPolicy.definition.operator': 'Operador',
  'accessPolicy.definition.values': 'Valores (separados por coma)',

  'accessPolicy.operator.equal': 'Igual',
  'accessPolicy.operator.notEqual': 'Distinto',
  'accessPolicy.operator.greaterThan': 'Mayor que',
  'accessPolicy.operator.greaterThanOrEqual': 'Mayor o igual',
  'accessPolicy.operator.lessThan': 'Menor que',
  'accessPolicy.operator.lessThanOrEqual': 'Menor o igual',
  'accessPolicy.operator.contains': 'Contiene',
  'accessPolicy.operator.notContains': 'No contiene',
  'accessPolicy.operator.isNull': 'Es nulo',
  'accessPolicy.operator.isNotNull': 'No es nulo',

  'accessPolicy.ruleType.scopeRole': 'Ámbito — rol',
  'accessPolicy.ruleType.scopeUserId': 'Ámbito — ID de usuario',
  'accessPolicy.ruleType.scopePositionId': 'Ámbito — ID de puesto',
  'accessPolicy.ruleType.scopeAreaId': 'Ámbito — ID de área',
  'accessPolicy.ruleType.scopeUserGroupId': 'Ámbito — ID de grupo',
  'accessPolicy.ruleType.scopeAppClientId': 'Ámbito — ID de cliente de app',
  'accessPolicy.ruleType.scopeAppId': 'Ámbito — ID de app',
  'accessPolicy.ruleType.scopePortalId': 'Ámbito — ID de portal',
  'accessPolicy.ruleType.ipSingle': 'IP — dirección única',
  'accessPolicy.ruleType.ipRange': 'IP — rango',
  'accessPolicy.ruleType.ipCidr': 'IP — CIDR',
  'accessPolicy.ruleType.geoCountryCode': 'Geo — código de país',
  'accessPolicy.ruleType.geoState': 'Geo — provincia / región',
  'accessPolicy.ruleType.geoCity': 'Geo — ciudad',
  'accessPolicy.ruleType.userAgent': 'User agent',
  'accessPolicy.ruleType.deviceKnown': 'Dispositivo conocido',
};
